import { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";

/**
 * QR code for a referral/share link with the My Within logo in the center.
 * Uses error-correction level "H" so the centered logo never breaks scanning.
 */
export function ReferralQR({ value, size = 190, label, downloadName = "my-within-empfehlung", testId = "referral-qr" }) {
  const ref = useRef(null);
  if (!value) return null;
  const logoSize = Math.round(size * 0.22);

  const download = () => {
    const canvas = ref.current?.querySelector("canvas");
    if (!canvas) return;
    const a = document.createElement("a");
    a.href = canvas.toDataURL("image/png");
    a.download = `${downloadName}.png`;
    a.click();
  };

  return (
    <div className="flex flex-col items-center gap-3" data-testid={testId}>
      <div ref={ref} className="rounded-2xl bg-white p-3 shadow-sm ring-1 ring-black/5">
        <QRCodeCanvas
          value={value}
          size={size}
          level="H"
          marginSize={2}
          bgColor="#ffffff"
          fgColor="#1f2d2b"
          imageSettings={{ src: "/brand/app_icon.png", height: logoSize, width: logoSize, excavate: true }}
        />
      </div>
      {label && <p className="max-w-[240px] break-all text-center text-xs text-muted-foreground">{label}</p>}
      <Button size="sm" variant="outline" className="gap-1.5 rounded-full" onClick={download} data-testid={`${testId}-download`}>
        <Download className="h-4 w-4" /> QR herunterladen
      </Button>
    </div>
  );
}
